// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-payment-js": () => import("./../../../src/pages/payment.js" /* webpackChunkName: "component---src-pages-payment-js" */),
  "component---src-pages-plasmic-host-tsx": () => import("./../../../src/pages/plasmic-host.tsx" /* webpackChunkName: "component---src-pages-plasmic-host-tsx" */),
  "component---src-templates-blog-post-js": () => import("./../../../src/templates/blog-post.js" /* webpackChunkName: "component---src-templates-blog-post-js" */),
  "component---src-templates-default-plasmic-page-tsx": () => import("./../../../src/templates/defaultPlasmicPage.tsx" /* webpackChunkName: "component---src-templates-default-plasmic-page-tsx" */)
}

